import {Payroll} from '@app/core/models/payroll.model';
import {Pagination} from '@app/core/models/pagination.model';

export interface IPayrollsState {
	payrolls: Payroll[];
	pagination: Pagination;
	selectedPayroll: Payroll | undefined;
	isLoading: boolean;
	isSelectedPayrollLoading: boolean;
}

export const initialPayrollsState: IPayrollsState = {
	payrolls: [],
	selectedPayroll: undefined,
	pagination: undefined,
	isLoading: false,
	isSelectedPayrollLoading: false,
};
